import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import Title from '@picsart/growth-rc/Title';
import Description from '@picsart/growth-rc/Description';
import { SummaryContentProps } from './types';

import useStyles from './style';

const SummaryContent = ({ summaryTitle, summaryContent }: SummaryContentProps) => {
  const classes = useStyles();
  return (
    <HorizontalContainer>
      <div className={classes.root}>
        <Title {...summaryTitle} className={classes.summaryTile} />
        <Description {...summaryContent} className={classes.description} />
      </div>
    </HorizontalContainer>
  );
};

export default SummaryContent;
